import {formater} from '../formater/formater';

$(document).ready(function(){
 
  var format = new formater();
  var $zip_field = $('#locality_zip_code');
  
  if ($zip_field.value !== "" && $zip_field.value !== "undefined" ){
    var cep = document.getElementById('locality_zip_code');  
    $zip_field.keyup(function(){
      cep.value= format.applyMasc(cep.value,'zipcode') 
    });
    $zip_field.focusout(function(){
      cep.value= format.applyMasc(cep.value,'zipcode') 
    });        
  };

});